import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "24",
  height: "24",
  transform: "translate(0.5)"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M20.6511 12.0102C21.1043 12.4636 21.3319 13.0155 21.3319 13.6606C21.3319 14.3059 21.1046 14.8588 20.6511 15.3123L16.898 19.0654C16.64 19.3234 16.336 19.4699 15.99 19.5025L15.8394 19.5094C15.4303 19.5094 15.0756 19.3601 14.7808 19.0654C14.4861 18.7706 14.3369 18.4159 14.3368 18.0068C14.3368 17.5977 14.4861 17.243 14.7808 16.9482L18.2377 13.4914C18.3403 13.3887 18.4643 13.334 18.605 13.334C18.7457 13.334 18.8697 13.3887 18.9724 13.4914C19.0748 13.594 19.1291 13.7175 19.1291 13.8581C19.1291 13.9988 19.0744 14.1228 18.9717 14.2254L15.5149 17.6822C15.4208 17.7764 15.3768 17.8832 15.3768 18.0068C15.3768 18.1303 15.4208 18.2373 15.5149 18.3313C15.609 18.4254 15.7159 18.4695 15.8394 18.4695C15.963 18.4694 16.0699 18.4254 16.164 18.3313L19.917 14.5783C20.1753 14.32 20.303 14.0153 20.303 13.6606C20.303 13.3061 20.1751 13.0025 19.917 12.7442C19.6587 12.4859 19.3547 12.3575 19 12.3575C18.6453 12.3575 18.3413 12.4859 18.083 12.7442L13.9349 16.8923C13.5192 17.308 13.3121 17.8091 13.3121 18.4018C13.3121 18.9944 13.5193 19.4956 13.9349 19.9113C14.3506 20.3269 14.8519 20.5341 15.4444 20.5341C16.037 20.5341 16.5383 20.3269 16.9539 19.9113L20.8057 16.0595C20.9084 15.9568 21.0324 15.902 21.1731 15.902C21.3137 15.9021 21.4372 15.9564 21.5398 16.0588C21.6424 16.1614 21.6972 16.2855 21.6972 16.4262C21.6972 16.5669 21.6425 16.6909 21.5398 16.7935L17.688 20.6453C17.0638 21.2695 16.3142 21.5837 15.4444 21.5838C14.5747 21.5838 13.8251 21.2694 13.2009 20.6453C12.6547 20.0991 12.3462 19.457 12.2777 18.7222L12.2625 18.4018C12.2625 17.5319 12.5767 16.7824 13.2009 16.1582L17.3489 12.0102C17.8024 11.5567 18.3547 11.3286 19 11.3286C19.6453 11.3286 20.1976 11.5567 20.6511 12.0102Z",
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-width": "0.2"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21.5 3L3.5 21",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.9955 11C7.89405 11 7.79217 10.9814 7.68986 10.9443C7.58754 10.9071 7.4975 10.8489 7.41974 10.7697L6.73929 10.1389C5.89945 9.35784 5.14961 8.59059 4.48976 7.8371C3.82992 7.08362 3.5 6.27643 3.5 5.41553C3.5 4.72992 3.72666 4.15591 4.17997 3.6935C4.63337 3.23117 5.19618 3 5.86842 3C6.25037 3 6.62766 3.08982 7.00029 3.26945C7.37284 3.44909 7.70608 3.7408 8 4.1446C8.29392 3.7408 8.62716 3.44909 8.99971 3.26945C9.37234 3.08982 9.74963 3 10.1316 3C10.8038 3 11.3666 3.23117 11.82 3.6935C12.2733 4.15591 12.5 4.72992 12.5 5.41553C12.5 6.28577 12.1645 7.10194 11.4934 7.86404C10.8224 8.62614 10.0742 9.38687 9.24887 10.1462L8.57564 10.7697C8.49796 10.8489 8.40721 10.9071 8.30339 10.9443C8.1995 10.9814 8.09687 11 7.9955 11Z",
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-width": "0.2",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_6 = ["width", "height"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("rect", {
  width: "24",
  height: "24",
  transform: "translate(0.5)"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.2713 20.5747C12.6655 19.9689 12.3626 19.2445 12.3626 18.4017C12.3626 17.5589 12.6655 16.8345 13.2713 16.2287L17.4197 12.0803C17.8543 11.6457 18.381 11.4284 19 11.4284C19.619 11.4284 20.1457 11.6457 20.5803 12.0803C21.0149 12.5149 21.2322 13.0417 21.2322 13.6607C21.2322 14.2796 21.0149 14.8064 20.5803 15.241L16.827 18.9943C16.5505 19.2709 16.2212 19.4092 15.8393 19.4092C15.4574 19.4092 15.1282 19.2709 14.8516 18.9943C14.575 18.7178 14.4368 18.3885 14.4368 18.0066C14.4368 17.6247 14.575 17.2955 14.8516 17.0189L18.3086 13.5619C18.3942 13.4763 18.493 13.4335 18.6049 13.4335C18.7169 13.4335 18.8156 13.4763 18.9012 13.5619C18.9868 13.6475 19.0296 13.7463 19.0296 13.8582C19.0296 13.9702 18.9868 14.0689 18.9012 14.1545L15.4442 17.6115C15.3323 17.7235 15.2763 17.8552 15.2763 18.0066C15.2763 18.1581 15.3323 18.2898 15.4442 18.4017C15.5562 18.5136 15.6879 18.5696 15.8393 18.5696C15.9908 18.5696 16.1225 18.5136 16.2344 18.4017L19.9877 14.6484C20.2643 14.3718 20.4026 14.0426 20.4026 13.6607C20.4026 13.2788 20.2643 12.9495 19.9877 12.673C19.7112 12.3964 19.3819 12.2581 19 12.2581C18.6181 12.2581 18.2888 12.3964 18.0123 12.673L13.8639 16.8214C13.4293 17.256 13.212 17.7827 13.212 18.4017C13.212 19.0207 13.4293 19.5474 13.8639 19.982C14.2985 20.4166 14.8253 20.6339 15.4442 20.6339C16.0632 20.6339 16.59 20.4166 17.0246 19.982L20.8767 16.13C20.9623 16.0444 21.061 16.0016 21.173 16.0016C21.2849 16.0016 21.3837 16.0444 21.4693 16.13C21.5549 16.2156 21.5977 16.3143 21.5977 16.4263C21.5977 16.5382 21.5549 16.637 21.4693 16.7226L17.6172 20.5747C17.0114 21.1805 16.2871 21.4834 15.4442 21.4834C14.6014 21.4834 13.8771 21.1805 13.2713 20.5747Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21.5 3L3.5 21",
  stroke: "currentColor",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.9955 11C7.89405 11 7.79217 10.9814 7.68986 10.9443C7.58754 10.9071 7.4975 10.8489 7.41974 10.7697L6.73929 10.1389C5.89945 9.35784 5.14961 8.59059 4.48976 7.8371C3.82992 7.08362 3.5 6.27643 3.5 5.41553C3.5 4.72992 3.72666 4.15591 4.17997 3.6935C4.63337 3.23117 5.19618 3 5.86842 3C6.25037 3 6.62766 3.08982 7.00029 3.26945C7.37284 3.44909 7.70608 3.7408 8 4.1446C8.29392 3.7408 8.62716 3.44909 8.99971 3.26945C9.37234 3.08982 9.74963 3 10.1316 3C10.8038 3 11.3666 3.23117 11.82 3.6935C12.2733 4.15591 12.5 4.72992 12.5 5.41553C12.5 6.28577 12.1645 7.10194 11.4934 7.86404C10.8224 8.62614 10.0742 9.38687 9.24887 10.1462L8.57564 10.7697C8.49796 10.8489 8.40721 10.9071 8.30339 10.9443C8.1995 10.9814 8.09687 11 7.9955 11Z",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'FavoriteAndWatchLaterIcon',
  props: {
  width: {
    type: Number,
    default: 26
  },
  height: {
    type: Number,
    default: 26
  },
  wrapperClass: {
    type: String,
    default: ""
  },
  checked: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.checked)
    ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        width: __props.width,
        height: __props.height,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        class: _normalizeClass(__props.wrapperClass)
      }, [
        _hoisted_2,
        _createTextVNode(),
        _hoisted_3,
        _createTextVNode(),
        _hoisted_4,
        _createTextVNode(),
        _hoisted_5
      ], 10, _hoisted_1))
    : (_openBlock(), _createElementBlock("svg", {
        key: 1,
        width: __props.width,
        height: __props.height,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        class: _normalizeClass(__props.wrapperClass)
      }, [
        _hoisted_7,
        _createTextVNode(),
        _hoisted_8,
        _createTextVNode(),
        _hoisted_9,
        _createTextVNode(),
        _hoisted_10
      ], 10, _hoisted_6))
}
}

})